import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from './breadcrumbs/Breadcrumbs';
import UsersList from './UsersList';
import './subheader.scss';
import { locationShape } from '../../routerPropTypes';
import ShakeFeature from '../shakeApp/ShakeFeature';

const Subheader = ({ currentItem, location, shakeAccess }) => {
  const isInProject = currentItem?.itemtype === 'project';
  const subHeaderClassName = isInProject ? 'subheaderProject' : 'subheader';
  return (
    <div className={subHeaderClassName}>
      <div className="wrapper">
        <Breadcrumbs currentItem={currentItem} location={location} />
        {isInProject && shakeAccess && <ShakeFeature projectId={currentItem.projectId} />}
        <UsersList />
      </div>
    </div>
  );
};
export default Subheader;

Subheader.propTypes = {
  // router prop types
  currentItem: PropTypes.object,
  location: PropTypes.shape(locationShape).isRequired,
};

Subheader.defaultProps = {
  currentItem: undefined,
};
